import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../AppIcon';

const ErrorState = ({ title, message, onRetry, retryText }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center p-8 text-center">
      <div className="w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center mb-4">
        <Icon name="AlertCircle" size={32} className="text-destructive" />
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-2">
        {title || t('common.error')}
      </h3>
      <p className="text-sm text-muted-foreground mb-6 max-w-md">
        {message || t('errors.serverError.description')}
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors flex items-center gap-2"
        >
          <Icon name="RefreshCw" size={16} />
          {retryText || t('errors.serverError.retry')}
        </button>
      )}
    </div>
  );
};

export default ErrorState;